import { gql, useMutation } from '@apollo/client';
import { Button } from '@mui/joy';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from '../../store/snackbar-slice';

const writeBedSensorSettingsMutation = gql`
  mutation WriteBedSensorSettings($_id: ID!) {
    writeBedSensorSettings(_id: $_id)
  }
`;

interface Props {
  _id: string;
}

function WriteSettingsButton({ _id }: Props) {
  const [writeSettings] = useMutation(writeBedSensorSettingsMutation);
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();

  const onClick = useCallback(async () => {
    setSaving(true);
    try {
      await writeSettings({ variables: { _id } });
      dispatch(
        showMessage({
          _id: 'write-bed-sensor-settings',
          severity: 'success',
          message: 'Success',
        }),
      );
    } catch (err: any) {
      console.error(err);
      dispatch(
        showMessage({
          _id: 'write-bed-sensor-settings',
          severity: 'danger',
          message: 'There was an error writing settings.',
        }),
      );
    }
    setSaving(false);
  }, [writeSettings, dispatch, _id]);

  return (
    <Button loading={saving} onClick={onClick} variant="solid" size="sm">
      Write Settings
    </Button>
  );
}

export default WriteSettingsButton;
